import { CardRegistrationUrlQuery } from "@/generated/graphql_billing";
import { graphql, HttpResponse } from "msw";

export const cardRegistrationUrlHandler =
  graphql.query<CardRegistrationUrlQuery>(
    "cardRegistrationUrl",
    ({ query, variables }) => {
      return HttpResponse.json({
        data: { cardRegistrationUrl: "https://www.google.com/" },
      });
    }
  );
